import { useState, useEffect } from "react";
import {
  SelectWithSearch,
  SaveButton,
  trans,
  CancelButton,
  ModalComponent,
  AddNewButton,
  InputText,
  InputTextArea,
  FieldLabel,
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { Commons, Const } from "../constants";
import { Button, Checkbox, Form, Switch, message, Skeleton, Row, Col, Tooltip } from 'antd';
import { getRelatedDataReq, createDataReq } from "./requests";
import { createSelectList, sortSelectListByLabel } from '@comps/commonFunctions';
import { DeleteOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import CreateTaxStrutcture from "../settings/taxStructures/components/CreateTaxStructure";
import CreatePayitem from "../settings/payitem/components/CreatePayitem";
import CreateFormula from "../settings/formula/components/CreateFormula";
import { payrollHelpText } from "../payrollHelpText";
import "./payrollModal.css";
import { makeFieldLabel } from "@utils/fieldTooltips";

const langKey = Const["payroll"].lngKey;
const formName = "createAttendanceRequest";
const payrollLabel = makeFieldLabel(payrollHelpText.payroll, { namespace: formName, label: (key) => trans(`${langKey}.${key}`) });
const commonLabel = (label, tooltip) => <FieldLabel label={ label } tooltip={ tooltip } />;

const CreatePayroll = (props) => {
  const [form] = Form.useForm()
  const [loader, setLoader] = useState(false);
  const [payitems, setPayitems] = useState([]);
  const [taxStructures, setTaxStructures] = useState([]);
  const [processAtMonthEnd, setProcessAtMonthEnd] = useState(false);
  const [isFixDays, setIsFixedDays] = useState(false);
  const [saving, setSaving] = useState(false)
  const [loading, setLoading] = useState(true)
  const [childComponent, setChildComponent] = useState(null)
  const selectedPayitems = Form.useWatch('payitems', form);

  useEffect(() => {
    getRelatedData();
    // eslint-disable-next-line
  }, []);

  const getRelatedData = () => {
    setLoading(true);
    makeRequest(setLoader, getRelatedDataReq, null, onGetRelatedDataSuccess, onGetRelatedDataError);
  }
  const onGetRelatedDataSuccess = (response) => {
    setPayitems(sortSelectListByLabel(createSelectList(response.payitems)))
    setTaxStructures(createSelectList(response.tax_structures))
    setLoading(false)
  };

  const onGetRelatedDataError = (err, res) => {
    message.error(res.response.data.message);
  }
  const onSubmit = (data) => {
    setSaving(true)
    const payload = {
      payroll: {
        ...data,
        company_id: localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1,
        is_fixed_days: isFixDays ? true : false,
        process_at_month_end: processAtMonthEnd,
        no_of_fixed_days: isFixDays ? data.no_of_fixed_days : null,
        processing_date: !processAtMonthEnd ? data.processing_date : null,
      }
    }
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
  }
  const onSuccess = (data, res) => {
    message.success("Saved successfully");
    props.onCompleted(data.payrolls.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {
    setSaving(false)

    message.error(res.response.data.message);
  }

  const onTaxStructureCreated = (data) => {
    if (data.length) {
      form.setFieldValue('tax_structure_id', data[0].id)
      setTaxStructures(createSelectList(data))
    }
    setChildComponent(null);
  };

  const onCreatePayitem = () => {
    setChildComponent(<CreatePayitem onCompleted={ onPayitemCreated } allData={ {} } onSuccess={ onPayitemCreated } />);
  }

  const onCreateFormula = () => {
    setChildComponent(<CreateFormula onCompleted={ onFormulaCreated } onSuccess={ onFormulaCreated } />);
  }

  const onPayitemCreated = (data) => {

    if (data && data.length > 0) {
      let obj = { label: data[0].name, value: data[0].id }
      setPayitems(prev => [...prev, obj]);
      setPayitems(sortSelectListByLabel(createSelectList(data)));
    }
    setChildComponent(null)
  }

  const onFormulaCreated = () => {
    setChildComponent(null)
  }

  const getPayitemOptions = (rowIndex) => {
    const rows = selectedPayitems || [];
    const currentPayitemId = rows[rowIndex]?.payitem_id;

    return payitems.filter((option) => {
      const optionValue = String(option.value);
      const selectedInAnotherRow = rows.some((row, index) => (
        index !== rowIndex && row?.payitem_id !== undefined && String(row.payitem_id) === optionValue
      ));

      return !selectedInAnotherRow || String(currentPayitemId) === optionValue;
    });
  }

  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  return (
    <>
      <ModalComponent top={ 20 } width={ 1200 } maskClosable={ false }
        mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
        visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
        { childComponent }
        <Skeleton loading={ loading }>
          <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } scrollToFirstError className="payroll-modal-form">
            <div className="payroll-modal-grid">
              <section className="payroll-form-section">
                <h5 className="payroll-form-section-title">Payroll details</h5>
                <Row gutter={ 20 }>
                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="name" rules={ rules.name } label={ payrollLabel('name') }>
                      <InputText placeholder={ trans(`${langKey}.name`) } />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <div className="klok-field-action">
                      <Form.Item name="tax_structure_id" rules={ rules.tax_structure_id } label={ payrollLabel('tax_structure_id') }>
                        <SelectWithSearch
                          options={ taxStructures }
                          placeholder={ trans(`${langKey}.tax_structure_id`) }
                        />
                      </Form.Item>
                        <AddNewButton onClick={ () => setChildComponent(<CreateTaxStrutcture onCompleted={ onTaxStructureCreated } />) } />
                    </div>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="is_tax_applicable" rules={ rules.is_tax_applicable } label={ payrollLabel('is_tax_applicable') }
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="description" rules={ rules.description } label={ payrollLabel('description') }>
                      <InputTextArea placeholder={ trans(`${langKey}.description`) } />
                    </Form.Item>
                  </Col>
                </Row>
              </section>

              <section className="payroll-form-section">
                <h5 className="payroll-form-section-title">Processing rules</h5>
                <Row gutter={ 20 }>
                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item label={ payrollLabel('process_at_month_end') } className="payroll-toggle-field">
                      <span className="payroll-switch-control">
                        <span>{ trans(`${langKey}.processing_date`) }</span>
                        <Switch className="payroll-reference-switch" onChange={ (value) => setProcessAtMonthEnd(value) } />
                        <span>{ trans(`${langKey}.at_end`) }</span>
                      </span>
                    </Form.Item>
                  </Col>

                  {
                    !processAtMonthEnd ?
                      <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                        <Form.Item name="processing_date" rules={ rules.processing_date } label={ payrollLabel('processing_date') }>
                          <InputText placeholder={ trans(`${langKey}.processing_date`) } type="number" onWheel={ (e) => e.target.blur() } />
                        </Form.Item>
                      </Col>
                      : ''
                  }

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item label={ payrollLabel('is_fixed_days') } className="payroll-toggle-field">
                      <span className="payroll-switch-control">
                        <span>{ trans(`${langKey}.actual`) }</span>
                        <Switch className="payroll-reference-switch" onChange={ (value) => setIsFixedDays(value) } />
                        <span>{ trans(`${langKey}.fixed`) }</span>
                      </span>
                    </Form.Item>
                  </Col>

                  { isFixDays ?
                    <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                      <Form.Item name="no_of_fixed_days" rules={ rules.no_of_fixed_days } label={ payrollLabel('no_of_fixed_days') }>
                        <InputText placeholder={ trans(`${langKey}.no_of_fixed_days`) } type="number" onWheel={ (e) => e.target.blur() } />
                      </Form.Item>
                    </Col>
                    : '' }
                </Row>
              </section>

              <div className="payroll-actions-bar">
                <div className="payroll-actions-group">
                  <Button type="default" onClick={ onCreateFormula }>Add Formula</Button>
                  <Button type="default" onClick={ onCreatePayitem }>Add Payitem</Button>
                </div>
                <Tooltip title="Refresh payroll setup lists">
                  <Button type="text" aria-label="Refresh payroll setup lists" icon={ <ReloadOutlined /> } onClick={ getRelatedData } />
                </Tooltip>
              </div>

              <div className="payroll-payitems-panel">
              <Form.List name="payitems" >
                { (fields, { add, remove }) => (
                  <>
                    <div className="payroll-payitems-header">
                      <h5 className="payroll-payitems-title">{ commonLabel(trans(`${langKey}.payitems`), payrollHelpText.payroll.payitems) }</h5>
                      <Button onClick={ () => add() } icon={ <PlusOutlined /> } type="primary">Add Item</Button>
                    </div>
                    {
                      fields.length !== 0 ?
                        <div className="payroll-table-wrap">
                          <table className="payroll-payitems-table">
                            <thead>
                            <tr>
                              <th>{ payrollLabel('payitem_id') }</th>
                              <th>{ payrollLabel('is_taxable') }</th>
                              <th>{ payrollLabel('arrear_applicable') }</th>
                              <th>{ payrollLabel('is_final_settlement') }</th>
                              <th>{ trans(Commons.actions) }</th>
                            </tr>
                            </thead>
                            <tbody>
                              { fields.map(({ key, name, ...restField }) => (
                                <tr key={ key }>
                                  <td>

                                    <Form.Item
                                      { ...restField }
                                      name={ [name, 'payitem_id'] }
                                      rules={ rules.payitem_id }
                                    >
                                      <SelectWithSearch
                                        options={ getPayitemOptions(name) }
                                        placeholder={ trans(`${langKey}.payitem_id`) } />
                                    </Form.Item>
                                  </td>
                                  <td className="payroll-checkbox-cell">
                                    <Form.Item
                                      { ...restField }
                                      name={ [name, 'is_taxable'] }
                                      rules={ rules.is_taxable }
                                    >
                                      <Checkbox />
                                    </Form.Item>
                                  </td>
                                  <td className="payroll-checkbox-cell">
                                    <Form.Item
                                      { ...restField }
                                      name={ [name, 'arrear_applicable'] }
                                      rules={ rules.arrear_applicable }
                                    >
                                      <Checkbox />
                                    </Form.Item>
                                  </td>
                                  <td className="payroll-checkbox-cell">
                                    <Form.Item
                                      { ...restField }
                                      name={ [name, 'is_final_settlement'] }
                                      rules={ rules.is_final_settlement }
                                    >
                                      <Checkbox />
                                    </Form.Item>
                                  </td>
                                  <td>
                                    <Tooltip title="Delete item">
                                      <Button
                                        type="text"
                                        danger
                                        aria-label="Delete item"
                                        icon={ <DeleteOutlined /> }
                                        onClick={ () => remove(name) }
                                      />
                                    </Tooltip>
                                  </td>
                                </tr>
                              )) }
                            </tbody>
                          </table>
                        </div>
                        :
                        <div className="payroll-empty-payitems">
                          <p className="payroll-empty-title">No pay items added</p>
                          <p className="payroll-empty-copy">Add earnings, deductions, or settlement items for this payroll.</p>
                          <Button onClick={ () => add() } icon={ <PlusOutlined /> } type="primary">Add Item</Button>
                        </div>
                    }
                  </>
                ) }
              </Form.List>
              </div>
            </div>
          </Form>
        </Skeleton>
      </ModalComponent>
    </>
  )
}

export default CreatePayroll

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.req`) },
  ],
  payitem_id: [
    { required: true, message: trans(`${langKey}.payitem_id.req`) },
  ],
  tax_structure_id: [
    { required: false, message: trans(`${langKey}.tax_structure_id`) },
  ],
  processing_date: [
    { required: true, message: trans(`${langKey}.processing_date.req`) },
  ],
  no_of_fixed_days: [
    { required: true, message: trans(`${langKey}.no_of_fixed_days.req`) },
  ],
  is_flat: [
    { required: true, message: trans(`${langKey}.is_flat.req`) },
  ],
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
